module.exports = __webpack_public_path__ + "static/img/2018.382e9af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2018.jpg
// module id = kjsG
// module chunks = 1